import { jsxs, jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import DateTime from "../../../../vendor/luxon/src/datetime.js";
import "../../../../vendor/luxon/src/duration.js";
import { useMemo } from "react";
import { useYearMonthSelector } from "./useYearMonthSelector.js";
import { CalendarCell } from "../../shared/fragments/CalendarCell/CalendarCell.js";
import { CalendarHeader } from "../../shared/fragments/CalendarHeader/CalendarHeader.js";
import { MonthYearSelector } from "../../shared/fragments/MonthYearSelector/MonthYearSelector.js";
import { WeekDaysStripe } from "../../shared/fragments/WeekDaysStripe.js";
import { useMonthCells } from "../../shared/hooks/useMonthCells.js";
import { inheritDataTestId } from "../../../../utils/dataTestId.js";
const MonthCalendar = ({
  selectedMonthDate,
  type,
  readonly,
  disabledTo,
  disabledFrom,
  selected,
  hoverDate,
  yearRange,
  range,
  onDateHover,
  onDateClick,
  onPrev,
  onNext,
  onMonthChanged,
  ...props
}) => {
  const items = useMonthCells(selectedMonthDate), weeks = [...Array(Math.ceil(items.length / 7))], today = useMemo(() => DateTime.now().toISODate(), []), {
    shown: yearMonthSelectorShown,
    type: typeOfMonthYearSelector,
    handleChange,
    toggleShown: toggleYearMonthSelectorShown,
    toggleMonthYear,
    close: closeYearMonthSelector
  } = useYearMonthSelector(type, onMonthChanged), calendarType = yearMonthSelectorShown && type === "single" ? typeOfMonthYearSelector : type;
  return /* @__PURE__ */ jsxs(Stack, { "data-test-id": inheritDataTestId(props, "container"), children: [
    /* @__PURE__ */ jsx(
      CalendarHeader,
      {
        "data-test-id": inheritDataTestId(props, "calendar-header"),
        readonly,
        type: calendarType,
        date: selectedMonthDate,
        onNext: yearMonthSelectorShown ? closeYearMonthSelector : onNext,
        onPrev: yearMonthSelectorShown ? closeYearMonthSelector : onPrev,
        onClick: toggleYearMonthSelectorShown,
        toggleMonthYear,
        back: closeYearMonthSelector,
        disabledTo,
        disabledFrom
      }
    ),
    /* @__PURE__ */ jsxs(Stack, { sx: styles.body, children: [
      /* @__PURE__ */ jsx(WeekDaysStripe, {}),
      /* @__PURE__ */ jsx(Stack, { className: "dates-view", children: weeks.map((_, weekIndex) => /* @__PURE__ */ jsx(Stack, { direction: "row", children: items.slice(7 * weekIndex, 7 * (weekIndex + 1)).map((d, j) => {
        const disabledToDate = (d == null ? void 0 : d.date) && disabledTo && d.date <= disabledTo, disabledFromDate = (d == null ? void 0 : d.date) && disabledFrom && d.date >= disabledFrom;
        return /* @__PURE__ */ jsx(
          CalendarCell,
          {
            "data-test-id": inheritDataTestId(
              props,
              `calendar-cell-${(d == null ? void 0 : d.date) ?? weekIndex + j}`
            ),
            content: d == null ? void 0 : d.content,
            current: today === (d == null ? void 0 : d.date),
            selected,
            isRange: range,
            date: d == null ? void 0 : d.date,
            onClick: onDateClick,
            disabled: disabledToDate || disabledFromDate,
            onHover: onDateHover,
            hoverDate
          },
          (d == null ? void 0 : d.id) ?? j
        );
      }) }, weekIndex)) }),
      /* @__PURE__ */ jsx(
        MonthYearSelector,
        {
          "data-test-id": inheritDataTestId(props, "month-year-selector"),
          type: typeOfMonthYearSelector,
          selected: selectedMonthDate,
          onChange: handleChange,
          show: yearMonthSelectorShown,
          from: yearRange[0],
          to: yearRange[1],
          disabledFrom,
          disabledTo
        }
      )
    ] })
  ] });
}, styles = {
  body: {
    paddingX: 6,
    position: "relative"
  }
};
export {
  MonthCalendar
};
//# sourceMappingURL=MonthCalendar.js.map
